import React from 'react';
import cn from 'classnames';
import cd from 'debug';
import { FormattedMessage } from 'react-intl';
import core from '@gin-betting/core';
import { capitalize } from 'lodash';

import LiveLabel from '../LiveLabel';
import globalMessages from 'messages';
import './dateTime.scss';

const { formatTimeAndDate } = core.utils;
const debug = cd('components:DateTime');
const { Fragment } = React;

interface OwnProps {
    isLiveMatch: boolean;
    startTime: string;
    styleName?: string;
    className?: string;
}

class DateTime extends React.Component<OwnProps> {
    render() {
        debug('render', this.props);

        const { startTime, isLiveMatch, className } = this.props;
        const { isToday, date, time } = formatTimeAndDate(startTime);

        return (
            <div
                styleName={cn('container', {
                    'is-today': isToday,
                })}
                className={cn('__app-DateTime-container', className)}
            >
                {isLiveMatch ? (
                    <LiveLabel />
                ) : (
                    <Fragment>
                        <div styleName="date" className="__app-DateTime-date">
                            {isToday ? time : capitalize(date)}
                        </div>
                        <div styleName="time" className="__app-DateTime-time">
                            {isToday ? (
                                <FormattedMessage
                                    {...globalMessages.todayText}
                                />
                            ) : (
                                time
                            )}
                        </div>
                    </Fragment>
                )}
            </div>
        );
    }
}

export default DateTime;
